<div class="bg-color-white">
  <div
    [ngStyle]="{ padding: '24px 4vw 32px' }"
    [ngStyle.gt-sm]="{ padding: '48px 4vw' }"
    class="u-position-relative"
  >
    <div [ngStyle]="{ 'max-width': '1280px' }" class="u-margin-center">
      <div
        [ngStyle]="{ margin: '0 0 24px' }"
        fxLayout="row"
        fxLayoutAlign="start start"
      >
        <div fxFlex="120px">
          <button
            class="c-button"
            (click)="
              reloadPage();
              trackInteractionAnalytics({
                actionType: 'click',
                targetId: 'logo'
              })
            "
          >
            <app-logo-square
              class="u-display-block"
              color="black"
              [fxShow.gt-sm]="true"
              [fxShow]="false"
            >
            </app-logo-square>
            <app-logo-square
              class="u-display-block"
              color="black"
              size="small"
              [fxShow.gt-sm]="false"
              [fxShow]="true"
            >
            </app-logo-square>
          </button>
        </div>
        <div fxFlex="100%" fxLayout="row" fxLayoutAlign="end center">
          <div [fxShow]="true" [fxShow.gt-xs]="false">
            <button
              mat-icon-button
              [matMenuTriggerFor]="menu"
              (click)="
                trackInteractionAnalytics({
                  actionType: 'click',
                  targetId: 'mobile-menu'
                })
              "
            >
              <mat-icon>menu</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <ng-container *ngIf="!isUserAuthenticated">
                <a
                  mat-menu-item
                  (click)="
                    trackInteractionAnalytics({
                      actionType: 'click',
                      targetId: 'mobile-signin'
                    })
                  "
                  href="/signin"
                >
                  Sign In
                </a>
              </ng-container>
              <ng-container *ngIf="isUserAuthenticated">
                <a
                  mat-menu-item
                  href="/home"
                  (click)="
                    trackInteractionAnalytics({
                      actionType: 'click',
                      targetId: 'mobile-go-to-app'
                    })
                  "
                >
                  Go To App
                </a>
              </ng-container>
              <a
                mat-menu-item
                href="//10kcblog.com"
                target="_blank"
                (click)="
                  trackInteractionAnalytics({
                    actionType: 'click',
                    targetId: 'mobile-blog'
                  })
                "
              >
                Blog
              </a>
              <button
                mat-menu-item
                class="c-button"
                (click)="
                  showCustomerServiceOption();
                  trackInteractionAnalytics({
                    actionType: 'click',
                    targetId: 'mobile-request-demo'
                  })
                "
              >
                {{ cta }}
              </button>
            </mat-menu>
          </div>
          <div
            [fxShow]="false"
            [fxShow.gt-xs]="true"
            fxLayout="row"
            fxLayoutAlign="end center"
          >
            <div class="u-marginRight-8">
              <ng-container *ngIf="!isUserAuthenticated">
                <a
                  mat-button
                  (click)="
                    trackInteractionAnalytics({
                      actionType: 'click',
                      targetId: 'signin'
                    })
                  "
                  href="/signin"
                >
                  Sign In
                </a>
              </ng-container>
              <ng-container *ngIf="isUserAuthenticated">
                <a
                  mat-button
                  (click)="
                    trackInteractionAnalytics({
                      actionType: 'click',
                      targetId: 'go-to-app'
                    })
                  "
                  href="/home"
                >
                  Go To App
                </a>
              </ng-container>
            </div>
            <div class="u-marginRight-16">
              <a
                mat-button
                (click)="
                  trackInteractionAnalytics({
                    actionType: 'click',
                    targetId: 'blog'
                  })
                "
                href="//10kcblog.com"
                target="_blank"
              >
                Blog
              </a>
            </div>
            <div class="u-marginRight-8">
              <button
                mat-raised-button
                color="primary"
                (click)="
                  showCustomerServiceOption();
                  trackInteractionAnalytics({
                    actionType: 'click',
                    targetId: 'request-demo-1'
                  })
                "
              >
                {{ cta }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="u-position-relative"
        fxLayout.gt-sm="row"
        fxLayout="column"
        fxLayoutAlign="start center"
      >
        <div fxFlex.gt-sm="532px" fxFlex="100%">
          <h2
            [ngStyle]="{
              'font-size': '32px',
              'line-height': '44px',
              'max-width': '523px'
            }"
            class="color-black text-playfair u-marginBottom-24"
          >
            {{ tagLine }}
          </h2>
          <div
            [ngStyle]="{
              'font-size': '16px',
              'line-height': '28px',
              'max-width': '523px'
            }"
            class="color-grey u-marginBottom-40"
          >
            <div class="u-marginBottom-32">
              Ten Thousand Coffees helps power one-to-one human connections in
              the workplace.
            </div>
          </div>
          <div
            [ngStyle]="{ 'max-width': '500px' }"
            fxLayout.gt-sm="row wrap"
            fxLayout="column"
            fxLayoutGap="16px"
            class="u-marginBottom-32"
          >
            <div>
              <button
                mat-raised-button
                color="primary"
                [ngClass.lt-md]="'u-width-100'"
                (click)="
                  showCustomerServiceOption();
                  trackInteractionAnalytics({
                    actionType: 'click',
                    targetId: 'request-demo-2'
                  })
                "
              >
                {{ cta }}
              </button>
            </div>
          </div>
        </div>
        <div
          fxFlex.gt-sm="calc(100% - 532px)"
          fxFlex="100%"
          fxLayout="row"
          fxLayoutAlign="start center"
          [ngClass.lt-md]="'u-marginBottom-24 u-marginTop-24'"
          [ngStyle.lt-md]="{ 'max-width': '500px' }"
          class="u-width-100"
        >
          <app-hero-illustration
            class="u-display-block u-width-100"
          ></app-hero-illustration>
        </div>
      </div>
    </div>
  </div>
  <div class="bg-color-grey-50" [ngStyle]="{ padding: '64px 4vw' }">
    <div [ngStyle]="{ 'max-width': '960px' }" class="u-margin-center">
      <h5 class="u-textAlign-center u-marginBottom-40">
        <b>Strong human-to-human relationships can yield:</b>
      </h5>
      <div fxLayout="row wrap" fxLayoutAlign="start start">
        <div
          fxFlex.gt-xs="0 0 25%"
          fxFlex="50%"
          class="u-paddingRight-24 u-textAlign-center"
        >
          <h1 class="u-marginBottom-16 text-playfair color-blue-900">7x</h1>
          <p [ngStyle]="{ fontSize: '16px' }">Higher employee engagement</p>
        </div>
        <div
          fxFlex.gt-xs="0 0 25%"
          fxFlex="50%"
          class="u-paddingRight-24 u-textAlign-center"
        >
          <h1 class="u-marginBottom-16 text-playfair color-blue-900">58%</h1>
          <p [ngStyle]="{ fontSize: '16px' }">Decrease in turnover</p>
        </div>
        <div
          fxFlex.gt-xs="0 0 25%"
          fxFlex="50%"
          class="u-paddingRight-24 u-textAlign-center"
        >
          <h1 class="text-playfair u-marginBottom-16 color-blue-900">19%</h1>
          <p [ngStyle]="{ fontSize: '16px' }">Increase in innovation</p>
        </div>
        <div
          fxFlex.gt-xs="0 0 25%"
          fxFlex="50%"
          class="u-paddingRight-24 u-textAlign-center"
        >
          <h1 class="text-playfair u-marginBottom-16 color-blue-900">8%</h1>
          <p [ngStyle]="{ fontSize: '16px' }">Higher productivity</p>
        </div>
      </div>
    </div>
  </div>
  <div class="u-borderBottom-grey100"></div>
  <div
    [ngStyle]="{ 'max-width': '980px', padding: '80px 4vw' }"
    class="u-margin-center"
  >
    <div [ngStyle]="{ marginBottom: '64px' }">
      <h5 class="u-textAlign-center u-marginBottom-8">
        <b>Why Ten Thousand Coffees?</b>
      </h5>
      <p class="text-subtitle-1 u-textAlign-center color-grey">
        One product, three opportunities
      </p>
    </div>
    <div
      fxLayout="row wrap"
      fxLayoutAlign="start start"
      [ngStyle.gt-xs]="{ marginBottom: '64px' }"
      [ngStyle]="{ marginBottom: '32px' }"
    >
      <div
        fxFlex.gt-xs="0 0 33%"
        fxFlex="100%"
        [ngClass.gt-xs]="'u-paddingRight-24'"
        [ngClass.xs]="'u-marginBottom-24 u-margin-center'"
        [ngStyle.xs]="{ 'max-width': '300px' }"
      >
        <div
          class="u-marginBottom-16"
          [ngStyle]="{ 'font-size': '16px' }"
          fxLayout="row"
        >
          <div fxFlex="32px">
            <svg
              width="21"
              height="18"
              viewBox="0 0 28 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M14 0L27.8564 24L0.143594 24L14 0Z" fill="#023082" />
            </svg>
          </div>
          <p fxFlex="calc(100% - 32px)">
            <b>Learning Development</b>
          </p>
        </div>
        <p class="color-grey-300">
          9/10 employees cite networking and learning through internal
          relationships as critical to their current and future career success.
        </p>
      </div>
      <div
        fxFlex.gt-xs="0 0 33%"
        fxFlex="100%"
        [ngClass.gt-xs]="'u-paddingRight-24'"
        [ngClass.xs]="'u-marginBottom-24 u-margin-center'"
        [ngStyle.xs]="{ 'max-width': '300px' }"
      >
        <div
          class="u-marginBottom-16"
          [ngStyle]="{ 'font-size': '16px' }"
          fxLayout="row"
        >
          <div fxFlex="32px">
            <svg
              width="21"
              height="18"
              viewBox="0 0 28 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M14 0L27.8564 24L0.143594 24L14 0Z" fill="#00695C" />
            </svg>
          </div>
          <p fxFlex="calc(100% - 32px)">
            <b>Career Development</b>
          </p>
        </div>
        <p class="color-grey-300">
          Investing in training, development, and coaching for your employees
          yields an average of a 50% return on that investment.
        </p>
      </div>
      <div
        fxFlex.gt-xs="0 0 33%"
        fxFlex="100%"
        [ngClass.gt-xs]="'u-paddingRight-24'"
        [ngClass.xs]="'u-marginBottom-24 u-margin-center'"
        [ngStyle.xs]="{ 'max-width': '300px' }"
      >
        <div
          class="u-marginBottom-16"
          [ngStyle]="{ 'font-size': '16px' }"
          fxLayout="row"
        >
          <div fxFlex="32px">
            <svg
              width="21"
              height="18"
              viewBox="0 0 28 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M14 0L27.8564 24L0.143594 24L14 0Z" fill="#D45D4B" />
            </svg>
          </div>
          <p fxFlex="calc(100% - 32px)">
            <b>Cultural Transformation</b>
          </p>
        </div>
        <p class="color-grey-300">
          Companies that invest in long-term employee experience programs are
          4.2x as profitable as those that don't.
        </p>
      </div>
    </div>
  </div>
  <div class="u-borderBottom-grey100"></div>
  <div class="bg-color-grey-50" [ngStyle]="{ padding: '80px 4vw' }">
    <div [ngStyle]="{ 'max-width': '980px' }" class="u-margin-center">
      <h5 class="u-textAlign-center u-marginBottom-8">
        <b>Our Clients.</b>
      </h5>
      <div
        [ngStyle]="{ 'max-width': '523px', 'margin-bottom': '40px' }"
        [ngClass.lt-md]="'u-padding-0-16'"
        class="u-textAlign-center color-grey u-margin-center text-subtitle-1"
      >
        We've helped hundreds of companies empower their teams through knowledge
        networks.
      </div>
      <div [ngStyle]="{ 'max-width': '1080px' }" class="u-margin-center">
        <div fxLayout="row wrap" fxLayoutAlign="start center">
          <img
            *ngFor="let partner of partnerImages"
            [src]="partner.src"
            [alt]="partner.alt"
            fxFlex.gt-xs="20%"
            fxFlex="50%"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="u-borderBottom-grey100"></div>
  <div [ngStyle]="{ padding: '80px 4vw' }">
    <div [ngStyle]="{ 'max-width': '980px' }" class="u-margin-center">
      <div fxLayout.gt-sm="row" fxLayout="column">
        <div
          fxFlex.gt-sm="540px"
          fxFlex="100%"
          [ngStyle.gt-sm]="{ 'padding-right': '32px' }"
          [ngStyle.lt-md]="{
            'max-width': '520px',
            'margin-left': 'auto',
            'margin-right': 'auto',
            width: '95vw'
          }"
          [ngClass.lt-md]="'u-marginBottom-24'"
        >
          <iframe
            allow="autoplay; encrypted-media"
            allowfullscreen
            class="u-width-100 mat-elevation-z2"
            frameborder="0"
            height="320px"
            src="https://www.youtube.com/embed/1IPJnpcLDuk?rel=0&amp;showinfo=0"
          >
          </iframe>
        </div>
        <div
          fxFlex.gt-sm="calc(100% - 540px)"
          fxFlex="100%"
          fxLayout="row"
          fxLayoutAlign="end start"
        >
          <div
            [ngStyle]="{ 'border-radius': '12px' }"
            [ngStyle.lt-md]="{
              'max-width': '300px',
              'margin-left': 'auto',
              'margin-right': 'auto'
            }"
            class="u-border-grey100 mat-elevation-z1 u-padding-24 u-marginBottom-24"
          >
            <div [ngStyle]="{ 'max-width': '50px' }" class="u-marginBottom-24">
              <img
                src="//storage.googleapis.com/ttc-static-images/landing/rbc-logo.7c5f3cf.svg"
                alt="RBC logo"
                class="u-width-100"
              />
            </div>
            <p
              class="color-grey-300 u-marginBottom-24"
              [ngStyle]="{ 'font-size': '14px' }"
            >
              "These conversations really show that you can be your true
              authentic self, and that you can be successful. When new employees
              make those connections and hear other people's stories, they feel
              like they can go into those settings and work environments and
              really have success."
            </p>
            <p>
              <b>Brien Convery</b>
            </p>
            <p class="color-grey-300 u-marginBottom-24">
              Director, Early Talent Acquisition and Engagement
            </p>
          </div>
        </div>
      </div>
      <div
        fxLayout="column"
        fxLayout.gt-sm="row"
        fxLayoutAlign="start start"
        class="u-marginBottom-32"
      >
        <div
          fxFlex.gt-sm="50%"
          fxFlex="100%"
          class="u-width-100"
          [ngClass.gt-sm]="'u-paddingRight-16'"
        >
          <div
            [ngStyle.lt-md]="{
              'max-width': '300px',
              'margin-left': 'auto',
              'margin-right': 'auto'
            }"
            [ngStyle]="{ 'border-radius': '12px' }"
            class="u-border-grey100 mat-elevation-z1 u-padding-24 u-marginBottom-24"
          >
            <div [ngStyle]="{ 'max-width': '110px' }" class="u-marginBottom-24">
              <img
                src="//storage.googleapis.com/ttc-static-images/landing/edelmen-logo.0d1bd83.svg"
                alt="Edelman logo"
                class="u-width-100"
              />
            </div>
            <p
              class="color-grey-300 u-marginBottom-24"
              [ngStyle]="{ 'font-size': '14px' }"
            >
              "Ten Thousand Coffees provides employees with an opportunity to
              better understand how to successfully navigate a large global firm
              and create connections in other offices. It also allows employees
              to get different perspectives on the way they approach their
              client challenges and opportunities."
            </p>
            <p>
              <b>Lisa Kimmel</b>
            </p>
            <p class="color-grey-300 u-marginBottom-24">
              Global Chair, Edelman Global Women's Executive Network
            </p>
          </div>
        </div>
        <div
          [ngClass.gt-sm]="'u-paddingLeft-16'"
          fxFlex.gt-sm="50%"
          fxFlex="100%"
          class="u-width-100"
        >
          <div
            [ngStyle.lt-md]="{
              'max-width': '300px',
              'margin-left': 'auto',
              'margin-right': 'auto'
            }"
            [ngStyle]="{ 'border-radius': '12px' }"
            class="u-border-grey100 mat-elevation-z1 u-padding-24 u-marginBottom-24"
          >
            <div [ngStyle]="{ 'max-width': '146px' }" class="u-marginBottom-24">
              <img
                src="//storage.googleapis.com/ttc-static-images/landing/pepsico.6a4c92d.svg"
                alt="Pepsico logo"
                class="u-width-100"
              />
            </div>
            <p
              class="color-grey-300 u-marginBottom-24"
              [ngStyle]="{ 'font-size': '14px' }"
            >
              "Often people feel like they need the big program - they need
              parameters, they need rules, they need regulations. And that
              process is difficult and it takes a lot of time. And I think
              what’s important about Ten Thousand Coffees is that it allows
              these things to be quick, efficient, fast, simple - and in today's
              environment, simple is good."
            </p>
            <p>
              <b>Dave Moncur</b>
            </p>
            <p class="color-grey-300 u-marginBottom-24">
              Vice President Human Resources
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="u-borderBottom-grey100"></div>
  <div [ngStyle]="{ padding: '80px 4vw' }" class="bg-color-grey-50">
    <div [ngStyle]="{ 'max-width': '1280px' }" class="u-margin-center">
      <div
        [ngStyle]="{
          'max-width': '523px',
          'margin-bottom': '40px',
          'text-transform': 'capitalize'
        }"
        [ngClass.lt-md]="'u-padding-0-16'"
        class="u-textAlign-center color-grey u-margin-center text-subtitle-1"
      >
        Proudly featured in
      </div>
      <div [ngStyle]="{ 'max-width': '768px' }" class="u-margin-center">
        <div fxLayout="row wrap" fxLayoutAlign="center center">
          <a
            *ngFor="let media of mediaImages"
            (click)="
              trackInteractionAnalytics({
                actionType: 'click',
                targetId: 'media-' + media.name
              })
            "
            [href]="media.href"
            target="_blank"
            class="u-display-block"
            fxFlex.gt-xs="33%"
            fxFlex="50%"
          >
            <img [src]="media.src" [alt]="media.alt" class="u-width-100" />
          </a>
        </div>
      </div>
    </div>
  </div>
  <app-footer
    (trackAnalytics)="trackInteractionAnalytics($event)"
    class="u-display-block"
  >
  </app-footer>
</div>
